/** Cache tag for the webhook log (registered in apiSlice's tagTypes). */
export enum WebhookLogTags {
  WebhookLog = "WebhookLog",
}
